import { jsx, jsxs } from 'react/jsx-runtime';
import { Button } from '../../../Button/Button.es.js';
import { Icon } from '../../../Icon/Icon.es.js';
import { useChatBubbleContext } from '../ChatBubble.Context/index.es.js';

const ChatBubbleFooter = ({ onCopy, onRefresh, onThumbsUp, onThumbsDown })=>{
    const { author } = useChatBubbleContext();
    if (author === 'user') {
        return jsx("div", {
            className: "cb-chat-bubble-footer user",
            children: jsxs(Button, {
                onClick: onCopy,
                size: "sm",
                variant: "text",
                children: [
                    jsx(Icon, {
                        name: "DuplicateSolid"
                    }),
                    jsx("span", {
                        children: "Copy"
                    })
                ]
            })
        });
    }
    return jsxs("div", {
        className: "cb-chat-bubble-footer ai",
        children: [
            onRefresh && jsx(Button, {
                label: "Refresh",
                onClick: onRefresh,
                size: "sm",
                variant: "secondary",
                iconOnly: true,
                children: jsx(Icon, {
                    name: "RefreshOutline"
                })
            }),
            onCopy && jsx(Button, {
                label: "Copy",
                onClick: onCopy,
                size: "sm",
                variant: "secondary",
                iconOnly: true,
                children: jsx(Icon, {
                    name: "DuplicateSolid"
                })
            }),
            onThumbsUp && jsx(Button, {
                label: "Thumbs up",
                onClick: onThumbsUp,
                size: "sm",
                variant: "secondary",
                iconOnly: true,
                children: jsx(Icon, {
                    name: "ThumbsUpOutline"
                })
            }),
            onThumbsDown && jsx(Button, {
                label: "Thumbs down",
                onClick: onThumbsDown,
                size: "sm",
                variant: "secondary",
                iconOnly: true,
                children: jsx(Icon, {
                    name: "ThumbsDownOutline"
                })
            })
        ]
    });
};

export { ChatBubbleFooter };
//# sourceMappingURL=ChatBubble.Footer.es.js.map
